<script>
	import { createEventDispatcher } from 'svelte'
	import moment from 'moment'
	import axios from 'axios'

	import Modal from '../../components/Modal/Modal.svelte'
	import ModalOverlay from '../../components/Modal/ModalOverlay.svelte'
	import ListField from '../Programs/ListField.svelte'
	import ListOperators from '../Programs/ListOperators.svelte'
	import SmartField from '../../components/SmartField/SmartField.svelte'
	import SmartSelect from '../../components/SmartField/SmartSelect.svelte'
	import userStore from '../../stores/user'
	import SideListEditorLayout from '../../components/SideListEditorLayout/SideListEditorLayout.svelte'
	import { background, notifySuccess } from '../../components/Notifications/AppNotifications.svelte'
	import Dialog from '../../components/Modal/Dialog.svelte'

	export let data
	export let create = false

	let ctrlsDisabled = false,
		deleteDialog = false,
		listType = 'datepicker',
		types = [
			{ value: '0', text: 'Ferie' },
			{ value: '1', text: 'Permesso' },
			{ value: '2', text: 'Malattia' }
		],
		viewDefaults = {
			user: 'Scegli operatore'
		},
		validFields = {
			user: true
		},
		view = {
			user: viewDefaults.user,
			start: '',
			end: ''
		},
		initialModel = '',
		model = {
			start: '',
			end: '',
			description: '',
			user: '',
			type: '0'
		}

	const dispatch = createEventDispatcher()

	async function save() {
		if (validateModel()) {
			ctrlsDisabled = true

			// console.log('save', model)
			// console.log('input data', data)
			background(true)
			const params = {
				...(data.hid ? { id: data.hid } : {}),
				...model
			}
			await axios.request({
				method: 'post',
				url: '/api/holidays/save',
				params
			})
			background(false)
			notifySuccess(`${typeName} salvate con successo`)
			dispatch('saved')
		}
	}

	function cancel() {
		ctrlsDisabled = true
		dispatch('cancel', { data })
	}

	function validateModel() {
		validFields.user = model.user !== ''

		return validFields.user
	}

	function loadData() {
		// console.log('load data', data)

		if (data.user) {
			model.user = data.user
			view.user = [
				{
					name: data.name,
					token_id: data.user
				}
			]
		}

		if (data.description) model.description = data.description
		if (data.type !== undefined) model.type = data.type.toString()

		if (data.originalStart) {
			model.start = moment(data.originalStart).valueOf()
			model.end = moment(data.originalEnd).valueOf()
		}

		initialModel = create ? '' : JSON.stringify(model)

		// console.log('start', model.start, 'end', model.end)
		// console.log('start', data.nextStart, 'end', data.nextEnd)

		model.start = moment(data.nextStart).valueOf()
		model.end = moment(data.nextEnd).valueOf()

		view.start = `Inizio: ${moment(data.nextStart).format('DD/MM/YYYY')}`
		view.end = `Fine: ${moment(data.nextEnd).format('DD/MM/YYYY')}`

		if (data.originalStart && model.start !== data.originalStart) {
			view.start = `Inizio ${moment(data.nextStart).format('DD/MM/YYYY')} (precedentemente: ${moment(data.originalStart).format('DD/MM/YYYY')}`
		}

		if (data.originalEnd && model.end !== data.originalEnd) {
			view.end = `Fine ${moment(data.nextEnd).format('DD/MM/YYYY')} (precedentemente: ${moment(data.originalEnd).format('DD/MM/YYYY')}`
		}
	}

	function onOperatorSelect(event) {
		const { detail } = event

		view.user = [
			{
				name: detail.name,
				token_id: detail.token_id
			}
		]
		model.user = detail.token_id
		validFields.user = true

		validFields = validFields
		view = view
		model = model
	}

	function getTypeName(type) {
		return types.find((it) => it.value === type).text
	}

	function deleteItem(event) {
		deleteDialog = true
	}

	function cancelDelete() {
		deleteDialog = false
	}

	async function confirmDelete() {
		const { hid: id } = data
		background(true)
		await axios.request({
			method: 'post',
			url: '/api/holidays/delete',
			params: {
				id
			}
		})
		background(false)
		notifySuccess(`${typeName} eliminate con successo`)
		deleteDialog = false
		cancel()
	}

	$: changed = initialModel !== JSON.stringify(model)
	$: typeName = getTypeName(model.type)
	$: if (data) loadData(data)
</script>

<ModalOverlay />
{#if data || create}
	<Modal classes="ProgramEditor" hideOverlay>
		<SideListEditorLayout title={create ? `Aggiungi ${typeName}` : `Modifica ${typeName}`}>
			<ListField name="dateFrom" value={view.start} />
			<ListField name="dateTo" value={view.end} />
			<ListField
				name="user"
				value={view.user}
				placeholder="Scegli operatore"
				valid={validFields.user}
				on:list={(e) => (listType = 'operators')}
			/>

			<SmartField name="description" label="Descrizione" bind:value={model.description} type="textarea" />
			<SmartSelect name="type" label="Tipo: " bind:value={model.type} options={types} legacy />

			{#if data.hid}
				<div class="flex justify-end items-center mt-4 gap-2">
					<div>Elimina questo elemento</div>
					<button class="btn btn-sm btn-warning" disabled={ctrlsDisabled} on:click={deleteItem}>
						Elimina {typeName}
					</button>
				</div>
			{/if}

			<div slot="list">
				<ListOperators
					sectorId={$userStore.sector.id}
					date={model.date}
					on:select={onOperatorSelect}
					on:app-event
				/>
			</div>
			<div slot="buttons">
				{#if changed}
					<button class="btn btn-sm btn-primary" disabled={ctrlsDisabled} on:click={save}>
						Salva Modifiche
					</button>
				{/if}
				<button class="btn btn-sm btn-danger" disabled={ctrlsDisabled} on:click={cancel}
					>Annulla modifiche</button
				>
			</div>
		</SideListEditorLayout>
	</Modal>
{/if}

{#if deleteDialog}
	<Dialog title="Vuoi davvero eliminare {typeName}?" on:cancel={cancelDelete} on:confirm={confirmDelete} leftAlign />
{/if}
